export default "__VITE_ASSET__Cn2c5lyd__"